import getCaptionForElement from 'src/js/modules/common/helpers/get-caption-for-element';
import isFocusedElement from '../verifiers/is-focused-element';
import isSelectedElement from '../verifiers/is-selected-element';

const APPROXIMATE_LABEL_WIDTH = 50;

const getHighlighterLabelOptions = (options, bounds, element) => {
  const { withElementSize, labelGap } = options;
  const { label } = getCaptionForElement(element);

  if (!withElementSize && (isFocusedElement(element) || isSelectedElement(element))) {
    return {
      label,
      fullwidthLabel: true,
    };
  }

  if (withElementSize) {
    const { left, width, height } = bounds;
    let position = 'center-bottom';

    if (left + width < APPROXIMATE_LABEL_WIDTH) {
      position = 'left-bottom';
    }

    return {
      label: `${Math.round(width)} x ${Math.round(height)}`,
      labelPosition: position,
      fullwidthLabel: true,
      ...(labelGap && { labelGap }),
    };
  }

  return {};
};

export default getHighlighterLabelOptions;
